import React from 'react'
import { Link } from 'react-router-dom'

// Import Img
import Img1 from "../../../assets/img/common/about.png"
import Img2 from "../../../assets/img/icon/about.png"


const AboutAres = () => {
  return (
    <>
      <section id="about_area" className="section_padding_bottom">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="about_area_img">
                        <img src={Img1} alt="img" />
                    </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="about_area_main_text">
                        <div className="about_area_heading">
                            <img src={Img2} alt="img" />
                            <h3>Welcome to PCF</h3>
                        </div>
                        <div className="about_area_heading_two">
                            <h2>Culture, education &amp; <span className="color_big_heading">integration</span> <br />
                                — with badminton leading the way</h2>
                            <h3>Pakistani families thriving in Sweden</h3>
                        </div>
                        <div className="about_area_para">
                            <h5>We are a Pakistani cultural and sports organisation in Sweden, run by volunteers who care
                                about the next generation and about life here in society.</h5>
                            <p>Alongside homework help and Urdu and cultural activities, we run <strong>integration support</strong>—
                                practical guidance on school, language practice, and meeting neighbours and institutions with
                                confidence. <strong>Badminton</strong> is our main year-round sport; we add <strong>swimming</strong>, <strong>cricket</strong>, and{' '}
                                <strong>football</strong> as seasonal programmes, and host <strong>social gatherings</strong> where families connect.</p>
                            <p>Parents and elders join cultural events, discussion evenings, and integration-themed meet-ups—
                                so Sweden feels more navigable, and our community feels more like home.</p>
                        </div>
                        <div className="about_vedio_area">
                            <Link to="/about" className="btn btn_theme btn_md">Learn more</Link>
                            <a href="#!" className="vedio_btn popup-vimeo"><i
                                    className="fa fa-play"></i>See our activities</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    </>
  )
}

export default AboutAres